import {createAction} from 'util/redux';
import {BSModelType, BSOwner} from 'module/BSCollection/type/BSCollectionStateType';
import {SisNameBS} from 'module/BSCollection/type/SisNameBS';

const NAMESPACE = 'BS/'
export const bsRefreshCollectionAction = createAction<{
	sisName: SisNameBS
	from: number
	to: number
	force?: boolean
	overrideOwners?: number[]
}>(NAMESPACE + 'RefreshCollection');

export const bsFetchCollectionAction = createAction<{
	sisName: SisNameBS
	owners: BSOwner[]
	fetchDates: number[]
	startTS: number
	endTS: number
}>(NAMESPACE + 'FetchCollection');

export const bsMergeResponseAction = createAction<{
	data: (BSModelType | null)[]
	sisName: SisNameBS
	owners: BSOwner[]
	fetchDates: number[]
	startTS: number
	endTS: number
}>(NAMESPACE + 'MergeResponse');

export const bsMergeModelChangeMapAction = createAction<{ sisName: SisNameBS, modelMap: Record<number | string, BSModelType | null> }>(NAMESPACE + 'MergeModelChangeMap')
export const bsSkipFetchCollectionAction = createAction<Parameters<typeof bsRefreshCollectionAction>[0]>(NAMESPACE + 'SkipFetchCollection')

export const refreshBSModelAction = createAction<{ sisName: SisNameBS, remove?: (BSModelType | null | undefined)[], add?: (BSModelType | null | undefined)[] }>(NAMESPACE + 'RefreshModel')

export const invalidateCacheAction = createAction<{
	sisName: SisNameBS,
	owners: BSOwner[],
	startTS: number,
	endTS: number,
}>(NAMESPACE + 'InvalidateCache')